module.exports = __webpack_public_path__ + "static/media/itau_logo.bd5ee802.png";